module.exports = "/_next/static/images/gene-su-e1429945e1384f40c726285d316ec6d7.jpg";